<template>
    <div>
        <button type="button" v-on:click="toggleModalWindow()">Hallo</button>
        <div id="myModal" class="modal" ref="myModal">
            <!-- Modal content -->
            <div class="modal-content">
                <span v-on:click="toggleModalWindow()" class="close">&times;</span>
                <div v-for="(key, placeholder) in items">
                    <input class="form-control" type="text" :id="key" :name="key" :placeholder="placeholder"/>
                </div>
                <button type="button" id="product_create_btn" class="form-control" v-on:click="createNew()">{{$t("page.product.view.delete_product_q")}}</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            "dataFields"
        ],
        bind: {
            items: [],
        },

        beforeMount: function() {
            this.items = JSON.parse(this.dataFields);
        },
        mounted: function() {
            let modal = this.$refs['myModal'];
            window.onclick = function (event) {
                if (event.target == modal) {
                    modal.style.display = "none";
                }
            };
        },
        methods: {
            toggleModalWindow: function() {
                let modalWindow = this.$refs['myModal'];

                if( modalWindow.style.display === "block"){
                    modalWindow.style.display = "none";
                } else {
                    modalWindow.style.display = "block";
                }
            },
            createNew: function () {
                if (confirm($t("page.product.view.delete_product_q"))) {
                    let data = {};

                    Object.values(this.items).forEach(function (value) {
                        data[""+value+""] = $('#'+value).val();
                    });

                    axion.post('/article/add', {
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        },
                        body: data
                    }).then(function (data) {
                        alert(trans('page.product.view.product_was_created'));
                        location.reload();
                    });
                }
            },

            update: function () {
                axios.post('/article/update/' + $('#hidden_update_field').val(), {
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    body: {
                        sku: $('#product_sku_u').val(),
                        alt_sku: $('#product_alt_sku_u').val(),
                        ean: $('#product_ean_u').val(),
                        name: $('#product_name_u').val(),
                        manufacturer: $('#product_manufacturer_u').val(),
                        comanufacturer: $('#product_comanufacturer_u').val(),
                        commodity_code: $('#product_commodityCode_u').val(),
                        weight: $('#product_weight_u').val(),
                        width: $('#product_width_u').val(),
                        height: $('#product_height_u').val(),
                        length: $('#product_length_u').val(),
                        status: $('#product_status_u').val(),
                        price_gros: $('#product_price_gros_u').val(),
                        price_net: $('#product_price_net_u').val()
                    }
                }).then(function (response) {
                    location.reload();
                });

            },
            delete: function () {
                if (confirm(trans('page.product.view.delete_product_q'))) {
                    let split = this.id.split("_", 2);

                    axios.post('/article/delete/' + split[1], {
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        },
                    }).then(function (response) {
                        alert(trans('page.product.view.product_was_deleted'));
                        location.reload();
                    });
                }
            },
            openUpdateWindow: function () {
                if (confirm(trans('page.product.view.add_product_q'))) {
                    let split = this.id.split("_", 2);
                    let modal = document.getElementById("myModal2");
                    modal.style.display = "block";
                    window.onclick = function (event) {
                        if (event.target == modal) {
                            modal.style.display = "none";
                        }
                    };

                    axios.get('/article/get_article/' + split[1], {
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        }
                    }).then(function (data) {
                        $('#product_sku_u').val(data["sku"]);
                        $('#product_alt_sku_u').val(data["sku_alternative"]);
                        $('#product_ean_u').val(data["ean"]);
                        $('#product_name_u').val(data["name"]);
                        $('#product_manufacturer_u').val(data["manufacturer"]);
                        $('#product_comanufacturer_u').val(data["country_of_manufacture"]);
                        $('#product_commodityCode_u').val(data["commodity_code"]);
                        $('#product_weight_u').val(data["weight"]);
                        $('#product_width_u').val(data["width"]);
                        $('#product_height_u').val(data["height"]);
                        $('#product_length_u').val(data["length"]);
                        $('#product_status_u').val(data["status"]);
                        $('#product_price_gros_u').val(data["price_gros"]);
                        $('#product_price_net_u').val(data["price_net"]);
                        $('#hidden_update_field').val(split[1]);
                    }).catch(function (error) {
                        modal.style.display = "none";
                    });
                }
            }
        }
    }















/*
        if(document.getElementById('product_hidden'))
    {
        var modal = document.getElementById("myModal");
        var btn = document.getElementById("popupCreateProduct");
        var span = document.getElementsByClassName("close")[0];
        btn.onclick = function () {
            modal.style.display = "block";
        };
        span.onclick = function () {
            modal.style.display = "none";
        };
        window.onclick = function (event) {
            if (event.target == modal) {
                modal.style.display = "none";
            }
        };
*/



        /*
        $('#product_create_btn').on('click', function () {
            if (confirm(trans('page.product.view.add_product_q'))) {
                $.ajax({
                    url: '/article/add',
                    type: "post",
                    dataType: "json",
                    data: {
                        sku: $('#product_sku').val(),
                        alt_sku: $('#product_alt_sku').val(),
                        ean: $('#product_ean').val(),
                        name: $('#product_name').val(),
                        manufacturer: $('#product_manufacturer').val(),
                        comanufacturer: $('#product_comanufacturer').val(),
                        commodity_code: $('#product_commodityCode').val(),
                        weight: $('#product_weight').val(),
                        width: $('#product_width').val(),
                        height: $('#product_height').val(),
                        length: $('#product_length').val(),
                        status: $('#product_status').val(),
                        price_gros: $('#product_price_gros').val(),
                        price_net: $('#product_price_net').val(),
                    },
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {
                        alert(trans('page.product.view.product_was_created'));
                        location.reload();

                    },
                    error: function () {
                    }
                });
            } else {
            }
        });
        */

/*
        $('#product_create_btn_u').on('click', function () {
            $.ajax({
                url: '/article/update/' + $('#hidden_update_field').val(),
                type: "post",
                dataType: "json",
                data: {
                    sku: $('#product_sku_u').val(),
                    alt_sku: $('#product_alt_sku_u').val(),
                    ean: $('#product_ean_u').val(),
                    name: $('#product_name_u').val(),
                    manufacturer: $('#product_manufacturer_u').val(),
                    comanufacturer: $('#product_comanufacturer_u').val(),
                    commodity_code: $('#product_commodityCode_u').val(),
                    weight: $('#product_weight_u').val(),
                    width: $('#product_width_u').val(),
                    height: $('#product_height_u').val(),
                    length: $('#product_length_u').val(),
                    status: $('#product_status_u').val(),
                    price_gros: $('#product_price_gros_u').val(),
                    price_net: $('#product_price_net_u').val(),
                },
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    location.reload();

                },
                error: function () {
                }
            });
        });

*/
/*
        $('.product_update_btn').on('click', function () {


            if (confirm(trans('page.product.view.add_product_q'))) {
                let split = this.id.split("_", 2);
                let modal = document.getElementById("myModal2");
                modal.style.display = "block";
                window.onclick = function (event) {
                    if (event.target == modal) {
                        modal.style.display = "none";
                    }
                };
                $.ajax({
                    url: '/article/get_article/' + split[1],
                    type: "get",
                    dataType: "json",
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {
                        $('#product_sku_u').val(data["sku"]);
                        $('#product_alt_sku_u').val(data["sku_alternative"]);
                        $('#product_ean_u').val(data["ean"]);
                        $('#product_name_u').val(data["name"]);
                        $('#product_manufacturer_u').val(data["manufacturer"]);
                        $('#product_comanufacturer_u').val(data["country_of_manufacture"]);
                        $('#product_commodityCode_u').val(data["commodity_code"]);
                        $('#product_weight_u').val(data["weight"]);
                        $('#product_width_u').val(data["width"]);
                        $('#product_height_u').val(data["height"]);
                        $('#product_length_u').val(data["length"]);
                        $('#product_status_u').val(data["status"]);
                        $('#product_price_gros_u').val(data["price_gros"]);
                        $('#product_price_net_u').val(data["price_net"]);
                        $('#hidden_update_field').val(split[1]);
                    },
                    error: function () {
                        modal.style.display = "none";
                    }
                });

            } else {
            }
        });
*/
        /*
        $('.product_delete_btn').on('click', function () {
            if (confirm(trans('page.product.view.delete_product_q'))) {
                let split = this.id.split("_", 2);
                $.ajax({
                    url: '/article/delete/' + split[1],
                    type: "post",
                    dataType: "json",
                    data: {},
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {
                        alert(trans('page.product.view.product_was_deleted'));
                        location.reload();

                    },
                    error: function () {
                    }
                });
            } else {
            }
        });
        */



</script>
